import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"
import "./Header.scss"
import Logo from "./Logo"

const Header = ({ menuState, setMenuState, setCursorHovered }) => {
  const location = useLocation()
  const [disabled, setDisabled] = useState(true)

  //determine if menu button should be disabled
  const disableMenu = () => {
    setDisabled(!disabled)
    setTimeout(() => {
      setDisabled(false)
      console.log("disabled")
    }, 1200)
  }

  useEffect(() => {
    setMenuState(false)
  }, [location])

  useEffect(() => {
    menuState ? setDisabled(false) : disableMenu()
  }, [menuState])

  const [scrolled, setScrolled] = useState("")
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY < 150) {
        return setScrolled("")
      } else if (window.scrollY > 150) {
        return setScrolled("scrolled")
      }
    })
  }, [])



  return (
    <div className={`Header ${scrolled}`}>
    {/* <div className={`Header ${scrolled}`}> */}
      <div className="HeaderGroup">
        <Link className="HeaderGroup-item" activeClassName="active" to="/">
          {/* <img className="HeaderLogo" src={require("../assets/logo.svg")}></img> */}
          <Logo />
        </Link>
        <Link className="HeaderGroup-item" activeClassName="active" to="/about">
          About
        </Link>
        <Link
          className="HeaderGroup-item"
          activeClassName="active"
          to="/events"
        >
          Events
        </Link>
        <Link
          className="HeaderGroup-item HeaderGroup-item-donate"
          activeClassName="active"
          to="/donate"
        >
          {/* <button>Donate</button> */}
          Donate
        </Link>

        <div className="hamburger-menu HeaderGroup-item">
          <button
            // onClick={handleMenu}
            onClick={() => setMenuState(!menuState)}
            disabled={disabled}
            menuState={menuState}
            className={"button button-trigger button-hamburger " + menuState}
            // className="hamburger-menu HeaderGroup-item"
            onMouseEnter={() => setCursorHovered(true)}
            onMouseLeave={() => setCursorHovered(false)}
          >
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Header
